// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"081382f7","442":"1dcd51e6","673":"53d62a88","958":"334b1985"}[chunkId] + ".chunk.js";
};